/**
 * Holds the site-wide smooth scrolling instance (lenis), created once in _app.
 * Every function is a no-op when smooth scrolling is off (reduced motion, or before it starts).
 */

interface SmoothScroller {
    stop: () => void
    start: () => void
    resize: () => void
    scrollTo: (target: number | string | HTMLElement, options?: { offset?: number, immediate?: boolean, force?: boolean }) => void
}

let instance: SmoothScroller | null = null

export const setSmoothScroller = (scroller: SmoothScroller | null): void => {
    instance = scroller
}

export const stopSmoothScroll = (): void => {
    instance?.stop()
}

export const startSmoothScroll = (): void => {
    instance?.start()
}

export const resizeSmoothScroll = (): void => {
    instance?.resize()
}

/** Scrolls smoothly when the scroller is running, otherwise falls back to the browser. Call only from handlers or effects. */
export const smoothScrollTo = (target: HTMLElement, offset = -88): void => {
    if (instance) {
        instance.scrollTo(target, { offset })

        return
    }

    const top = target.getBoundingClientRect().top + window.scrollY + offset

    window.scrollTo({ top, behavior: 'smooth' })
}
